"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M32 9a9 9 0 0 0-18 0v16a9 9 0 0 0 18 0z" }),
  React.createElement("path", { d: "M38 25v-4.5a.5.5 0 0 0-.5-.5H36a.5.5 0 0 0-.5.5v4.085A12.772 12.772 0 0 1 23.234 37.5 12.5 12.5 0 0 1 10.5 25v-4.5a.5.5 0 0 0-.5-.5H8.5a.5.5 0 0 0-.5.5v4.076a15.292 15.292 0 0 0 13.75 15.355V44H13a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-8.75v-4.066A14.991 14.991 0 0 0 38 25z" })
);

